import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const ImageUploadSection = ({ user, coverFile, setCoverFile, profileFile, setProfileFile }) => {
    const getDisplayUrl = (file, currentUrl) => {
        if (file) return URL.createObjectURL(file);
        if (!currentUrl) return "/public/noAvatar.png";
        return currentUrl.startsWith("http") ? currentUrl : "/upload/" + currentUrl;
    };

    return (
        <div className="files">
            <label htmlFor="cover">
                <span>
                    Cover Picture
                </span>

                <div className="imgContainer">
                    <img
                        src={getDisplayUrl(coverFile, user.coverPic)}
                        alt="Cover Preview"
                    />

                    <CloudUploadIcon className="icon" />
                </div>
            </label>

            <input
                type="file"
                id="cover"
                style={{ display: "none" }}
                onChange={(e) => setCoverFile(e.target.files[0])}
            />

            <label htmlFor="profile">
                <span>
                    Profile Picture
                </span>

                <div className="imgContainer">
                    <img
                        src={getDisplayUrl(profileFile, user.profilePic)}
                        alt="Profile Preview"
                    />

                    <CloudUploadIcon className="icon" />
                </div>
            </label>

            <input
                type="file"
                id="profile"
                style={{ display: "none" }}
                onChange={(e) => setProfileFile(e.target.files[0])}
            />
        </div>
    );
};

export default ImageUploadSection;